import { ReactElement } from "react";

export type ScavengerHunt = {
  title: string;
  huntingText: ReactElement;
  solutionCode: string;
  congratsText: ReactElement;
};

export const CheckCode = (code: string, solutionCode: string) => {
  return code.toLowerCase() === solutionCode.toLowerCase();
};
